import { ActionRef } from 'further-types/lp/action';
import { LpInvestorUpdateType } from 'further-types/lp/investor-update';
import { CalendarDay, CalendarTime } from 'further-ui/utils';

export enum VehiclePageTab {
  Overview = 'overview',
  LatestActivity = 'latest-activity',
  Holdings = 'holdings',
  Onboarding = 'onboarding',
}

export type VehicleOverview = {
  totalCommitment: number;
  paidInCapital: number;
  unfundedCommitment: number;
  nonRecallableDistributions: number;
  recallableDistributions: number;
  capitalRefund: number;
  advanceSubscriptionBalanceLcy: number;
};

export type VehicleActivity = {
  id: string;
  vehicleId: string;
  title: string;
  callToActionTitle: string;
  date: CalendarDay;
  requiresAction: boolean;
  viewedAt?: CalendarTime;
} & (
  | {
      actionRef: ActionRef;
      updateType?: never;
    }
  | {
      updateType: LpInvestorUpdateType;
      actionRef?: never;
    }
);

export type Holding = {
  id: string;
  assetName: string;
  assetImage: string;
  investmentDate: CalendarDay;
  investedCapitalLcy: number;
  currentHoldValueLcy: number;
  grossMoic: number;
  sector?: string;
  stage?: string;
};
